import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * Microsoft Excel-style icon.
 * Uses the official Excel brand green (#1D6F42) regardless of any color prop,
 * so it's instantly recognizable in toolbars and table cells.
 */
const ExcelIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function ExcelIcon(props, ref) {
  return (
    <SvgIcon
      ref={ref}
      viewBox="0 0 24 24"
      {...props}
      sx={{ color: '#1D6F42', ...(props.sx as object) }}
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="currentColor" />
      <path d="M14 2v6h6" fill="#0E5732" opacity="0.55" />
      <path
        d="M9.1 11.5h1.85l1.05 1.95 1.05-1.95H14.9l-1.85 3 1.95 3.05h-1.9l-1.15-2.05-1.15 2.05H8.95l1.95-3.1z"
        fill="#fff"
      />
    </SvgIcon>
  );
});

export default ExcelIcon;
